var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTimeColonIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 20,
    viewBox: "0 0 4 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.009C4 17.4419 3.83261 16.9653 3.49784 16.5792C3.15152 16.181 2.65512 15.9819 2.00866 15.9819C1.36219 15.9819 0.871573 16.181 0.536797 16.5792C0.190476 16.9653 0.0173159 17.4419 0.0173159 18.009C0.0173159 18.5641 0.190476 19.0347 0.536797 19.4208C0.871573 19.8069 1.36219 20 2.00866 20C2.65512 20 3.15152 19.8069 3.49784 19.4208C3.83261 19.0347 4 18.5641 4 18.009ZM3.98268 2.02715C3.98268 1.46003 3.8153 0.983409 3.48052 0.597285C3.1342 0.199095 2.63781 0 1.99134 0C1.34488 0 0.854257 0.199095 0.51948 0.597285C0.17316 0.983409 0 1.46003 0 2.02715C0 2.5822 0.17316 3.05279 0.51948 3.43891C0.854257 3.82504 1.34488 4.0181 1.99134 4.0181C2.63781 4.0181 3.1342 3.82504 3.48052 3.43891C3.8153 3.05279 3.98268 2.5822 3.98268 2.02715Z",
    fill: "#4A525F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimeColonIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/time_colon_icon.ca4e2253.svg";
export { ForwardRef as ReactComponent };